import baseTheme from './base-theme';

const darkTheme = {
  ...baseTheme,
  mode: 'dark',
  variants: {
    primary: {
      color: baseTheme.colors.whiteGrey,
    },
    basicPage: {
      color: 'lightBlue',
      backgroundColor: 'black',
    },
    container: {
      backgroundColor: 'ghostBlack',
    },
    logo: {
      color: 'midLightGrey',
    },
    flexTableCell: {
      flexGrow: 0,
      flexShrink: 0,
    },
  },
  text: {
    title: {
      color: 'superLightGrey',
    },
    label: {
      color: 'midLightGrey',
    },
    primary: {
      color: 'isabelline',
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: '135%',
    },
    primaryDisabled: {
      color: 'cloud',
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: '135%',
    },
    primarySmall: {
      color: 'isabelline',
      fontWeight: 400,
      fontSize: '11px',
      lineHeight: '135%',
    },
    primaryBold: {
      color: 'isabelline',
      fontWeight: 700,
      fontSize: '13px',
      lineHeight: '135%',
    },
    subtitle1: {
      color: 'cloud',
      textTransform: 'uppercase',
      fontWeight: 500,
      fontSize: '13px',
    },
    subtitle2: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18.9px',
      color: 'softMidGrey',
    },
    placeholder: {
      color: 'whiteGrey',
      fontWeight: 400,
      fontSize: '13px',
      fontStyle: 'italic',
      lineHeight: '135%',
      opacity: 0.4,
    },
    error: {
      color: 'redLight',
    },
    success: {
      color: '#A0C125',
    },
    warn: {
      color: '#EAC348',
    },
    h1: {
      lineHeight: '120%',
      color: '#FFFFFF',
      fontWeight: 400,
      fontSize: '24px',
    },
    h2: {
      fontWeight: 400,
      fontSize: '20px',
      lineHeight: '120%',
      color: '#FFFFFF',
    },
    h3: {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '120%',
      color: '#FFFFFF',
    },
    h4: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '125%',
      color: '#CCCCCC',
    },
    h5: {
      fontWeight: 500,
      fontSize: '13px',
      lineHeight: '120%',
      color: 'cloud',
    },
    p1: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '125%',
      color: '#7B7E92',
    },
    p2: {
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: '135%',
      color: 'cloud',
    },
    p3: {
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: '135%',
      color: 'whiteGrey',
    },
    breadcrumbs: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '125%',
      color: '#7B7E92',
    },
    info: {
      fontStyle: 'italic',
      color: 'midLightGrey',
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: '18px',
    },
    hoverable: {
      color: 'lavender',
      fontWeight: 400,
      fontSize: '13px',
      cursor: 'pointer',
      borderBottomWidth: '1px',
      borderBottomStyle: 'dashed',
      paddingBottom: '1px',
      '&:hover': {
        borderBottomWidth: '0px',
        borderBottomStyle: 'none',
      },
      error: {
        color: 'redLight',
        fontWeight: 400,
        fontSize: '13px',
        cursor: 'pointer',
        borderBottomWidth: '1px',
        borderBottomStyle: 'dashed',
        paddingBottom: '1px',
        '&:hover': {
          borderBottomWidth: '0px',
          borderBottomStyle: 'none',
        },
      },
    },
    hoverableBold: {
      color: 'lavender',
      fontWeight: 700,
      fontSize: '13px',
      cursor: 'pointer',
      borderBottomWidth: '1px',
      borderBottomStyle: 'dashed',
      paddingBottom: '1px',
      '&:hover': {
        borderBottomWidth: '0px',
        borderBottomStyle: 'none',
      },
      error: {
        color: 'redLight',
        fontWeight: 700,
        fontSize: '13px',
        cursor: 'pointer',
        borderBottomWidth: '1px',
        borderBottomStyle: 'dashed',
        paddingBottom: '1px',
        '&:hover': {
          borderBottomWidth: '0px',
          borderBottomStyle: 'none',
        },
      },
    },
    tooltip: {
      fontSize: '12px',
      lineHeight: '16px',
      color: '#000000',
      fontWeight: 400,
    },
  },
};

export default darkTheme;
